import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import SidebarWidget from '~/components/common/sidebar-widget';

/**
 * Portal using beautiful react dnd
 */
class SidebarWidgetPortal extends Component {
	/**
	 * Render function
	 */
	render() {
		return ReactDOM.createPortal(
			<SidebarWidget
				title={ this.props.title }
				content={ this.props.content }
				type={ this.props.type }
			/>,
			document.getElementById( this.props.el )
		);
	}
}

// Validate prop types
SidebarWidgetPortal.propTypes = {
	el: PropTypes.string,
	title: PropTypes.string,
	content: PropTypes.string,
	type: PropTypes.string,
};

export default SidebarWidgetPortal;
